import { BreachEvent, click_origin_breach_screen } from '@news-mono/web-common'
import React from 'react'
import { AuthenticationProvider } from '../../../../../user-registration/authentication/AuthenticationProvider'
import { createLinkClickEvent } from '../../../createLinkClickHandler'
import SubscriptionPackage, {
    SubscriptionPackageProps,
} from '../../SubscriptionPackage/SubscriptionPackage'
import {
    StyledBlackFridayBreachContent,
    StyledButton,
    StyledButtonCaption,
    StyledMessage,
    StyledPackage,
    StyledRegistrationInfo,
    StyledTitle,
} from './BlackFridayBreachContent.styled'

export interface BlackFridayBreachContentProps {
    title: string
    message: React.ReactNode
    cta: string
    subscriptionPackages?: SubscriptionPackageProps[]

    breachCreativeName: string
    breachDeal: string
    onEvent: (event: BreachEvent) => void
}

export const BlackFridayBreachContent: React.FC<BlackFridayBreachContentProps> =
    ({
        title,
        message,
        cta,
        subscriptionPackages,
        breachCreativeName,
        breachDeal,
        onEvent,
    }) => (
        <AuthenticationProvider onEvent={onEvent}>
            {({ onSubscribeClick }) => (
                <StyledBlackFridayBreachContent>
                    <StyledRegistrationInfo>
                        <StyledTitle>{title}</StyledTitle>
                        <StyledMessage>{message}</StyledMessage>

                        <StyledButton
                            onClick={() => {
                                createLinkClickEvent(
                                    breachCreativeName,
                                    breachDeal,
                                    onEvent,
                                )()
                                onSubscribeClick({
                                    callToAction: click_origin_breach_screen,
                                })
                            }}
                        >
                            {cta}
                        </StyledButton>
                        <StyledButtonCaption>
                            Offer only available online.
                        </StyledButtonCaption>
                    </StyledRegistrationInfo>
                    <StyledPackage>
                        {subscriptionPackages &&
                            subscriptionPackages.map(
                                (subscriptionPackageItem, index) => {
                                    return (
                                        <SubscriptionPackage
                                            key={index}
                                            breachCreativeName={
                                                breachCreativeName
                                            }
                                            breachDeal={breachDeal}
                                            onEvent={
                                                subscriptionPackageItem.onEvent
                                            }
                                            ribbonTitle={
                                                subscriptionPackageItem.ribbonTitle
                                            }
                                            pretitle={
                                                subscriptionPackageItem.pretitle
                                            }
                                            heading={
                                                subscriptionPackageItem.heading
                                            }
                                            price={
                                                subscriptionPackageItem.price
                                            }
                                            originalPrice={
                                                subscriptionPackageItem.originalPrice
                                            }
                                            priceQualifier={
                                                subscriptionPackageItem.priceQualifier
                                            }
                                            packagePath={
                                                subscriptionPackageItem.packagePath
                                            }
                                            offerCode={
                                                subscriptionPackageItem.offerCode
                                            }
                                            packageType={
                                                subscriptionPackageItem.packageType
                                            }
                                        />
                                    )
                                },
                            )}
                    </StyledPackage>
                </StyledBlackFridayBreachContent>
            )}
        </AuthenticationProvider>
    )

BlackFridayBreachContent.displayName = 'BlackFridayBreachContent'

export default BlackFridayBreachContent
